import { composeValidations } from './common.js';

const HTTPS_PREFIX = 'https://';

export const EXTERNAL_PAGE_URL_ERROR =
  'Please enter a valid URL with a domain (e.g. example.com).';

function normalizeUrlSuffix(value: string): string {
  let suffix = value.trim();

  while (/^https?:\/\//i.test(suffix)) {
    suffix = suffix.replace(/^https?:\/\//i, '');
  }

  return suffix;
}

export function normalizeExternalPageUrl(value: string): string {
  const trimmed = value.trim();

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  return `${HTTPS_PREFIX}${normalizeUrlSuffix(trimmed)}`;
}

export function isValidExternalPageUrl(value: string): boolean {
  const url = normalizeExternalPageUrl(value);

  if (!URL.canParse(url)) {
    return false;
  }

  const { hostname } = new URL(url);

  return hostname === 'localhost' || hostname.includes('.');
}

export function createDashboardExternalPageUrlValidation() {
  return composeValidations<string>([
    [(value) => normalizeUrlSuffix(value).length > 0, 'Please enter a URL.'],
    [isValidExternalPageUrl, EXTERNAL_PAGE_URL_ERROR],
  ]);
}
